<!-- ===================== MODAL (vídeo Caso de éxito) ===================== -->
<div id="modal-container" [class.four]="modalOpen">
  <div class="modal-background">
    <div class="close-bar">
      <button type="button" (click)="closeModal()" aria-label="Cerrar">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M20.707 3.293a1 1 0 0 1 0 1.414l-16 16a1 1 0 0 1-1.414-1.414l16-16a1 1 0 0 1 1.414 0Z" fill="currentColor"></path>
          <path d="M3.293 3.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414Z" fill="currentColor"></path>
        </svg>
      </button>
    </div>
    <div class="modal">
      <iframe *ngIf="modalUrl as url" [src]="url" title="Caso de éxito" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
    </div>
  </div>
</div>

<!-- ===================== HERO / INTRO ===================== -->
<section class="intro" id="sistema">
  <div class="copy">
    <span class="eyebrow">{{ 'sistema.eyebrow' | translate }}</span>
    <h1 [innerHTML]="'sistema.titleHtml' | translate"></h1>
    <p>{{ 'sistema.intro' | translate }}</p>
    <button class="btn outline" type="button" (click)="openModal()">
      <svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>
      {{ 'sistema.caseBtn' | translate }}
    </button>
  </div>
  <div class="media">
    <iframe [src]="introVideoUrl" title="Vídeo introductorio Sistema Gesvatec" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
  </div>
</section>

<!-- ===================== APLICACIONES (2 tarjetas) ===================== -->
<section class="apps">
  <span class="eyebrow">{{ 'sistema.apps.eyebrow' | translate }}</span>
  <h2 class="section-title" [innerHTML]="'sistema.apps.titleHtml' | translate"></h2>
  <p class="section-lead center">{{ 'sistema.apps.lead' | translate }}</p>
  <div class="apps-grid">
    <a class="app-card" (click)="scrollTo('web')">
      <span class="ac-num">{{ 'sistema.apps.c1Num' | translate }}</span>
      <h3>{{ 'sistema.apps.c1Title' | translate }}</h3>
      <p>{{ 'sistema.apps.c1Text' | translate }}</p>
      <span class="ac-link">{{ 'sistema.apps.c1Link' | translate }}</span>
    </a>
    <a class="app-card" (click)="scrollTo('software')">
      <span class="ac-num">{{ 'sistema.apps.c2Num' | translate }}</span>
      <h3>{{ 'sistema.apps.c2Title' | translate }}</h3>
      <p>{{ 'sistema.apps.c2Text' | translate }}</p>
      <span class="ac-link">{{ 'sistema.apps.c2Link' | translate }}</span>
    </a>
  </div>
</section>

<!-- ===================== APLICACIÓN WEB (PackCert) ===================== -->
<section class="app-section" id="web">
  <div class="app-head">
    <span class="eyebrow">{{ 'sistema.web.eyebrow' | translate }}</span>
    <h2 class="section-title" [innerHTML]="'sistema.web.titleHtml' | translate"></h2>
    <p class="section-lead">{{ 'sistema.web.lead' | translate }}</p>
  </div>

  <!-- ¿Qué podrá hacer? (pestañas) -->
  <h3 class="block-title">{{ 'sistema.web.usersTitle' | translate }}</h3>
  <div class="tabs">
    <button [class.active]="activeUser === 'envasador'" (click)="activeUser = 'envasador'">{{ 'sistema.web.tabEnvasador' | translate }}</button>
    <button [class.active]="activeUser === 'entidad'" (click)="activeUser = 'entidad'">{{ 'sistema.web.tabEntidad' | translate }}</button>
  </div>
  <div class="icon-grid" *ngIf="activeUser === 'envasador'">
    <div class="icon-item" *ngFor="let icon of envasadorIcons; let i = index">
      <div class="tile"><img [src]="icon" alt=""></div>
      <p [innerHTML]="'sistema.web.envasador.' + i | translate"></p>
    </div>
  </div>
  <div class="icon-grid" *ngIf="activeUser === 'entidad'">
    <div class="icon-item" *ngFor="let icon of entidadIcons; let i = index">
      <div class="tile"><img [src]="icon" alt=""></div>
      <p [innerHTML]="'sistema.web.entidad.' + i | translate"></p>
    </div>
  </div>

  <!-- Monitorización GIS -->
  <div class="feature-block">
    <div class="fb-text">
      <h3>{{ 'sistema.web.gisTitle' | translate }}</h3>
      <p [innerHTML]="'sistema.web.gisTextHtml' | translate"></p>
    </div>
    <div class="fb-media">
      <iframe [src]="gisVideoUrl" title="Monitorización GIS" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen></iframe>
    </div>
  </div>
  <div class="system-images">
    <ul class="system-images__list">
      <li class="system-images__item" *ngFor="let img of gis.items; let i = index"
          [attr.data-pos]="gis.pos[i]" [style.background-image]="'url(' + img + ')'" (click)="center(gis, i)"></li>
    </ul>
    <div class="carousel-nav">
      <button (click)="nav(gis, 'left')" aria-label="Anterior"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12.086 4.105.703.704a.38.38 0 0 1 .106.28.514.514 0 0 1-.106.317l-5.45 5.45h11.99c.116 0 .222.046.316.14a.38.38 0 0 1 .105.281v.985a.514.514 0 0 1-.105.316.514.514 0 0 1-.317.106H7.34l5.45 5.449c.07.094.105.199.105.316a.38.38 0 0 1-.106.281l-.703.704a.514.514 0 0 1-.316.105.38.38 0 0 1-.282-.105L4.141 12.05A.334.334 0 0 1 4 11.77c0-.118.047-.211.14-.282l7.348-7.383A.38.38 0 0 1 11.77 4c.117 0 .222.035.316.105Z" fill="currentColor"></path></svg></span></button>
      <button (click)="nav(gis, 'right')" aria-label="Siguiente"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m11.664 4.105-.703.704a.38.38 0 0 0-.106.28c0 .118.036.223.106.317l5.45 5.45H4.42a.437.437 0 0 0-.316.14.38.38 0 0 0-.105.281v.985c0 .117.035.222.105.316.094.07.2.106.317.106H16.41l-5.45 5.449a.514.514 0 0 0-.105.316.38.38 0 0 0 .106.281l.703.704c.094.07.2.105.316.105a.38.38 0 0 0 .282-.105l7.347-7.383a.334.334 0 0 0 .141-.281.334.334 0 0 0-.14-.282l-7.348-7.383A.38.38 0 0 0 11.98 4a.514.514 0 0 0-.316.105Z" fill="currentColor"></path></svg></span></button>
    </div>
  </div>

  <!-- Central de Avisos -->
  <div class="feature-block reverse">
    <div class="fb-text">
      <h3>{{ 'sistema.web.warningsTitle' | translate }}</h3>
      <p [innerHTML]="'sistema.web.warningsTextHtml' | translate"></p>
    </div>
    <div class="fb-media">
      <iframe [src]="warningsVideoUrl" title="Central de Avisos" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen></iframe>
    </div>
  </div>
  <div class="system-images">
    <ul class="system-images__list">
      <li class="system-images__item" *ngFor="let img of warnings.items; let i = index"
          [attr.data-pos]="warnings.pos[i]" [style.background-image]="'url(' + img + ')'" (click)="center(warnings, i)"></li>
    </ul>
    <div class="carousel-nav">
      <button (click)="nav(warnings, 'left')" aria-label="Anterior"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12.086 4.105.703.704a.38.38 0 0 1 .106.28.514.514 0 0 1-.106.317l-5.45 5.45h11.99c.116 0 .222.046.316.14a.38.38 0 0 1 .105.281v.985a.514.514 0 0 1-.105.316.514.514 0 0 1-.317.106H7.34l5.45 5.449c.07.094.105.199.105.316a.38.38 0 0 1-.106.281l-.703.704a.514.514 0 0 1-.316.105.38.38 0 0 1-.282-.105L4.141 12.05A.334.334 0 0 1 4 11.77c0-.118.047-.211.14-.282l7.348-7.383A.38.38 0 0 1 11.77 4c.117 0 .222.035.316.105Z" fill="currentColor"></path></svg></span></button>
      <button (click)="nav(warnings, 'right')" aria-label="Siguiente"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m11.664 4.105-.703.704a.38.38 0 0 0-.106.28c0 .118.036.223.106.317l5.45 5.45H4.42a.437.437 0 0 0-.316.14.38.38 0 0 0-.105.281v.985c0 .117.035.222.105.316.094.07.2.106.317.106H16.41l-5.45 5.449a.514.514 0 0 0-.105.316.38.38 0 0 0 .106.281l.703.704c.094.07.2.105.316.105a.38.38 0 0 0 .282-.105l7.347-7.383a.334.334 0 0 0 .141-.281.334.334 0 0 0-.14-.282l-7.348-7.383A.38.38 0 0 0 11.98 4a.514.514 0 0 0-.316.105Z" fill="currentColor"></path></svg></span></button>
    </div>
  </div>

  <!-- Central de Estadísticas -->
  <div class="feature-block">
    <div class="fb-text">
      <h3>{{ 'sistema.web.statsTitle' | translate }}</h3>
      <p>{{ 'sistema.web.statsText1' | translate }}</p>
      <p [innerHTML]="'sistema.web.statsText2Html' | translate"></p>
    </div>
    <div class="fb-media">
      <iframe [src]="statsVideoUrl" title="Central de Estadísticas" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
    </div>
  </div>
  <div class="system-images">
    <ul class="system-images__list">
      <li class="system-images__item" *ngFor="let img of statistics.items; let i = index"
          [attr.data-pos]="statistics.pos[i]" [style.background-image]="'url(' + img + ')'" (click)="center(statistics, i)"></li>
    </ul>
    <div class="carousel-nav">
      <button (click)="nav(statistics, 'left')" aria-label="Anterior"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12.086 4.105.703.704a.38.38 0 0 1 .106.28.514.514 0 0 1-.106.317l-5.45 5.45h11.99c.116 0 .222.046.316.14a.38.38 0 0 1 .105.281v.985a.514.514 0 0 1-.105.316.514.514 0 0 1-.317.106H7.34l5.45 5.449c.07.094.105.199.105.316a.38.38 0 0 1-.106.281l-.703.704a.514.514 0 0 1-.316.105.38.38 0 0 1-.282-.105L4.141 12.05A.334.334 0 0 1 4 11.77c0-.118.047-.211.14-.282l7.348-7.383A.38.38 0 0 1 11.77 4c.117 0 .222.035.316.105Z" fill="currentColor"></path></svg></span></button>
      <button (click)="nav(statistics, 'right')" aria-label="Siguiente"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m11.664 4.105-.703.704a.38.38 0 0 0-.106.28c0 .118.036.223.106.317l5.45 5.45H4.42a.437.437 0 0 0-.316.14.38.38 0 0 0-.105.281v.985c0 .117.035.222.105.316.094.07.2.106.317.106H16.41l-5.45 5.449a.514.514 0 0 0-.105.316.38.38 0 0 0 .106.281l.703.704c.094.07.2.105.316.105a.38.38 0 0 0 .282-.105l7.347-7.383a.334.334 0 0 0 .141-.281.334.334 0 0 0-.14-.282l-7.348-7.383A.38.38 0 0 0 11.98 4a.514.514 0 0 0-.316.105Z" fill="currentColor"></path></svg></span></button>
    </div>
  </div>

  <!-- Gestión de Royalties -->
  <div class="feature-block reverse">
    <div class="fb-text">
      <h3>{{ 'sistema.web.royaltiesTitle' | translate }}</h3>
      <p [innerHTML]="'sistema.web.royaltiesTextHtml' | translate"></p>
    </div>
    <div class="fb-media">
      <iframe [src]="royaltiesVideoUrl" title="Gestión de Royalties" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowfullscreen></iframe>
    </div>
  </div>
  <div class="system-images">
    <ul class="system-images__list">
      <li class="system-images__item" *ngFor="let img of royalties.items; let i = index"
          [attr.data-pos]="royalties.pos[i]" [style.background-image]="'url(' + img + ')'" (click)="center(royalties, i)"></li>
    </ul>
    <div class="carousel-nav">
      <button (click)="nav(royalties, 'left')" aria-label="Anterior"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12.086 4.105.703.704a.38.38 0 0 1 .106.28.514.514 0 0 1-.106.317l-5.45 5.45h11.99c.116 0 .222.046.316.14a.38.38 0 0 1 .105.281v.985a.514.514 0 0 1-.105.316.514.514 0 0 1-.317.106H7.34l5.45 5.449c.07.094.105.199.105.316a.38.38 0 0 1-.106.281l-.703.704a.514.514 0 0 1-.316.105.38.38 0 0 1-.282-.105L4.141 12.05A.334.334 0 0 1 4 11.77c0-.118.047-.211.14-.282l7.348-7.383A.38.38 0 0 1 11.77 4c.117 0 .222.035.316.105Z" fill="currentColor"></path></svg></span></button>
      <button (click)="nav(royalties, 'right')" aria-label="Siguiente"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m11.664 4.105-.703.704a.38.38 0 0 0-.106.28c0 .118.036.223.106.317l5.45 5.45H4.42a.437.437 0 0 0-.316.14.38.38 0 0 0-.105.281v.985c0 .117.035.222.105.316.094.07.2.106.317.106H16.41l-5.45 5.449a.514.514 0 0 0-.105.316.38.38 0 0 0 .106.281l.703.704c.094.07.2.105.316.105a.38.38 0 0 0 .282-.105l7.347-7.383a.334.334 0 0 0 .141-.281.334.334 0 0 0-.14-.282l-7.348-7.383A.38.38 0 0 0 11.98 4a.514.514 0 0 0-.316.105Z" fill="currentColor"></path></svg></span></button>
    </div>
  </div>
</section>

<!-- ===================== SOFTWARE DE ESCRITORIO (PackDesk) ===================== -->
<section class="app-section alt" id="software">
  <div class="app-head">
    <span class="eyebrow">{{ 'sistema.software.eyebrow' | translate }}</span>
    <h2 class="section-title" [innerHTML]="'sistema.software.titleHtml' | translate"></h2>
    <p class="section-lead">{{ 'sistema.software.lead' | translate }}</p>
  </div>

  <!-- ¿Qué podrán hacer? + impresoras -->
  <div class="feature-block">
    <div class="fb-text">
      <h3 class="mb">{{ 'sistema.software.usersTitle' | translate }}</h3>
      <div class="icon-grid single">
        <div class="icon-item" *ngFor="let icon of softwareItemIcons; let i = index">
          <div class="tile"><img [src]="icon" alt=""></div>
          <p [innerHTML]="'sistema.software.items.' + i | translate"></p>
        </div>
      </div>
    </div>
    <div class="fb-media plain">
      <img [src]="printers" [alt]="'sistema.software.printersAlt' | translate">
      <p class="printers-caption" [innerHTML]="'sistema.software.printersTextHtml' | translate"></p>
    </div>
  </div>

  <!-- Envasado en tiempo real -->
  <div class="block-head spaced">
    <h3>{{ 'sistema.software.realtimeTitle' | translate }}</h3>
    <p [innerHTML]="'sistema.software.realtimeTextHtml' | translate"></p>
  </div>
  <div class="system-images">
    <ul class="system-images__list">
      <li class="system-images__item" *ngFor="let img of software.items; let i = index"
          [attr.data-pos]="software.pos[i]" [style.background-image]="'url(' + img + ')'" (click)="center(software, i)"></li>
    </ul>
    <div class="carousel-nav">
      <button (click)="nav(software, 'left')" aria-label="Anterior"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m12.086 4.105.703.704a.38.38 0 0 1 .106.28.514.514 0 0 1-.106.317l-5.45 5.45h11.99c.116 0 .222.046.316.14a.38.38 0 0 1 .105.281v.985a.514.514 0 0 1-.105.316.514.514 0 0 1-.317.106H7.34l5.45 5.449c.07.094.105.199.105.316a.38.38 0 0 1-.106.281l-.703.704a.514.514 0 0 1-.316.105.38.38 0 0 1-.282-.105L4.141 12.05A.334.334 0 0 1 4 11.77c0-.118.047-.211.14-.282l7.348-7.383A.38.38 0 0 1 11.77 4c.117 0 .222.035.316.105Z" fill="currentColor"></path></svg></span></button>
      <button (click)="nav(software, 'right')" aria-label="Siguiente"><span><svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m11.664 4.105-.703.704a.38.38 0 0 0-.106.28c0 .118.036.223.106.317l5.45 5.45H4.42a.437.437 0 0 0-.316.14.38.38 0 0 0-.105.281v.985c0 .117.035.222.105.316.094.07.2.106.317.106H16.41l-5.45 5.449a.514.514 0 0 0-.105.316.38.38 0 0 0 .106.281l.703.704c.094.07.2.105.316.105a.38.38 0 0 0 .282-.105l7.347-7.383a.334.334 0 0 0 .141-.281.334.334 0 0 0-.14-.282l-7.348-7.383A.38.38 0 0 0 11.98 4a.514.514 0 0 0-.316.105Z" fill="currentColor"></path></svg></span></button>
    </div>
  </div>

  <!-- Etiqueta Certificada (carrusel circular con auto-rotación) -->
  <div class="block-head">
    <h3>{{ 'sistema.software.labelTitle' | translate }}</h3>
    <p>{{ 'sistema.software.labelText' | translate }}</p>
    <a class="btn-more" routerLink="/etiqueta">{{ 'sistema.software.saberMas' | translate }}
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>
    </a>
  </div>
  <div class="system-images">
    <ul class="system-images__list">
      <li class="system-images__item label" *ngFor="let img of labels.items; let i = index"
          [attr.data-pos]="labels.pos[i]" [style.background-image]="'url(' + img + ')'" (click)="center(labels, i)"></li>
    </ul>
  </div>

  <!-- Integración del volumen de kilos envasados -->
  <div class="feature-block reverse">
    <div class="fb-text">
      <h3>{{ 'sistema.software.apiTitle' | translate }}</h3>
      <p [innerHTML]="'sistema.software.apiTextHtml' | translate"></p>
    </div>
    <div class="fb-media plain">
      <img [src]="apiImg" alt="API" onerror="this.style.display='none'">
    </div>
  </div>
</section>
